import backend, {LOOM_API} from 'utils/backend/loom/api_library';

import queryString from 'query-string';

import {
  adaptLoomLeadDetail,
  adaptLoomLeadList,
  toLoomLeadListQuery,
} from './loom_lead_adapter';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Leads Loom reads can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const queryClient = async (filters, sort, lastEvaluatedKey) => {
  const query = queryString.stringify(
      {...toLoomLeadListQuery(filters, sort, lastEvaluatedKey), includeFamilyMembers: true},
      {skipNull: true, skipEmptyString: true},
  );
  const response = await backend.get(`${loomApi()}/api/careos/clients?${query}`);
  return adaptLoomLeadList(response);
};

// Takes Loom's client id. Intake leads created in Loom have no legacy RN.
const getClient = async (clientId) => {
  const response = await backend.get(`${loomApi()}/api/careos/clients/${encodeURIComponent(clientId)}`);
  return adaptLoomLeadDetail(response);
};

export default {
  getClient,
  queryClient,
};
